// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import styled from 'styled-components'

import { Button as LMFButton, TypeStyle } from '@syconium/little-miss-figgy'

import { Label as SharedLabel } from '../../shared-form-styles'
import * as Name from '../../TextEmbroideryForm/FormBody/Name'

export const LearnMoreLink = styled(Link)`
  text-decoration: underline;
`

export const WarningLabel = styled(TypeStyle.BodyNano)`
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  background-color: ${props => props.theme.color.deprecated.stoneLighter};
  border-radius: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(4)};
  margin-bottom: ${props => props.theme.spacing(6)};
  line-height: 20px;
`

export const HeadlineMicro = styled(TypeStyle.HeadlineMicro)`
  margin: ${props => props.theme.spacing(6)} 0;
  font-weight: ${o => o.theme.typography.font.weight[400]};
  letter-spacing: 0.65px;
  line-height: 22px;
  font-size: 13px;
`

export const Button = styled(LMFButton)`
  width: 100%;
  line-height: 18px;
  padding: ${props => props.theme.spacing(4)} 0;
  margin-bottom: ${props => props.theme.spacing(6)};
`
export const Label = styled(SharedLabel)`
  display: flex;
  justify-content: space-between;
  margin: ${props => props.theme.spacing(6)} 0 ${props => props.theme.spacing(2)} 0;
  align-items: center;
`

export const MicroCaps = styled(TypeStyle.HeadlineMicro)`
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  line-height: ${o => o.theme.typography.font.lineHeight.loose};
`

export const StyledNameWrapper = styled(Name.Wrapper)`
  h4 {
    letter-spacing: 1.6px;
    line-height: 16px;
  }
`

export const UploadedFileName = styled(TypeStyle.BodyNano)`
  margin-top: ${o => o.theme.spacing(1)};
  font-weight: 500;
`
